<mat-form-field appearance="outline" class="w-100" *ngIf="!multiple">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [required]="required"
    [disabled]="isDisabled"
    [compareWith]="compareFn"
    [value]="selectedValue"
    (selectionChange)="handleSelectionChange($event.value)"
    (openedChange)="onDropdownOpened($event)"
    [panelClass]="'searchable-dropdown-panel-single'"
  >
    <mat-select-trigger>
      {{
        selectedValue ?
          (displayWithFn ? displayWithFn(selectedValue) : selectedValue[displayKey])
          : placeholder
      }}
    </mat-select-trigger>

    <!-- 🔒 Prevent closing dropdown -->
    <div class="mat-select-search" (click)="$event.stopPropagation()">
      <div class="search-input-wrapper">
        <input
          #searchInput
          matInput
          [placeholder]="placeholder"
          [formControl]="searchControl"
          (click)="$event.stopPropagation()"
          (keydown.space)="$event.stopPropagation()"
          autocomplete="off"
        />
        <button
          mat-icon-button
          type="button"
          aria-label="Clear / Close"
          class="clear-search-btn"
          (click)="onCloseClick($event)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <!--          (keydown)="$event.stopPropagation()"-->
    </div>

    <!-- Normal options -->
    <mat-option
      *ngFor="let option of filteredOptions$ | async"
      [value]="option"
    >
      {{ displayWithFn ? displayWithFn(option) : option[displayKey] }}
    </mat-option>
    <!-- Show when no results -->
    <mat-option *ngIf="(filteredOptions$ | async)?.length === 0" [disabled]="isNoDataAvailable">
      No data available
    </mat-option>

  </mat-select>
  <button *ngIf="isShowPlusIcon"
          mat-icon-button
          matSuffix
          type="button"
          [matTooltip]="addTooltipPlusIcon || 'Add dropdown option'"
          (click)="onAddButtonClick($event)"
  >
    <mat-icon>add</mat-icon>
  </button>
<!--  <button-->
<!--    mat-icon-button-->
<!--    matSuffix-->
<!--    type="button"-->
<!--    aria-label="Refresh"-->
<!--    (click)="onRefreshClick($event)">-->
<!--    <mat-icon style="color: #757575">refresh</mat-icon>-->
<!--  </button>-->
</mat-form-field>
<mat-form-field appearance="outline" class="w-100" *ngIf="multiple">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    *ngIf="multiple && hideSelectAllOption"
    multiple
    [required]="required"
    [disabled]="isDisabled"
    [compareWith]="compareFnM"
    [value]="selectedValue"
    (openedChange)="onDropdownOpened($event)"
    [panelClass]="'searchable-dropdown-panel'"
  >
    <!--        (selectionChange)="onMultipleChange($event.value)"-->
    <mat-select-trigger>
      <ng-container *ngIf="selectedValue?.length; else noSel">

        <!-- First selected item -->
        {{ displayWithFn ? displayWithFn(selectedValue[0]) : selectedValue[0][displayKey] }}

        <!-- If more than 1 selected -->
        <ng-container *ngIf="selectedValue.length > 1">
          + {{ selectedValue.length - 1 }} more
        </ng-container>

      </ng-container>

      <ng-template #noSel>
        {{ placeholder }}
      </ng-template>
    </mat-select-trigger>

    <div class="mat-select-search" (click)="$event.stopPropagation()">
      <div class="search-input-wrapper">
      <input
        #searchInput
        matInput
        [placeholder]="placeholder"
        [formControl]="searchControl"
        (click)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()"
        autocomplete="off"
      />
        <button
          mat-icon-button
          type="button"
          aria-label="Clear / Close"
          class="clear-search-btn"
          (click)="onCloseClick($event)">
          <mat-icon>close</mat-icon>
        </button>
    </div>
    </div>
    <div class="select-all-row" (click)="toggleSelectAllMultiple(); $event.stopPropagation()"
         *ngIf="!hideSelectAllOption">
      <mat-icon class="select-all-icon">done_all</mat-icon>
      <span class="select-all-text">Select All</span>
    </div>
    <mat-option
      *ngFor="let option of filteredOptions$ | async"
      [value]="option"
      (onSelectionChange)="onOptionToggle(option, $event)">
      {{ displayWithFn ? displayWithFn(option) : option[displayKey] }}
    </mat-option>


    <mat-option *ngIf="(filteredOptions$ | async)?.length === 0" disabled>
      No data available
    </mat-option>

  </mat-select>
  <mat-select
    *ngIf="multiple && !hideSelectAllOption"
    multiple
    [required]="required"
    [disabled]="isDisabled"
    [compareWith]="compareFnM"
    [value]="selectedValue"
    (openedChange)="onDropdownOpened($event)"
    (selectionChange)="handleSelectionChange($event.value)"
    [panelClass]="'searchable-dropdown-panel'">
    <!--        (selectionChange)="onMultipleChange($event.value)"-->
    <mat-select-trigger>
      <ng-container *ngIf="selectedValue?.length; else noSel">

        <!-- First selected item -->
        {{ displayWithFn ? displayWithFn(selectedValue[0]) : selectedValue[0][displayKey] }}

        <!-- If more than 1 selected -->
        <ng-container *ngIf="selectedValue.length > 1">
          + {{ selectedValue.length - 1 }} more
        </ng-container>

      </ng-container>

      <ng-template #noSel>
        {{ placeholder }}
      </ng-template>
    </mat-select-trigger>

    <div class="mat-select-search" (click)="$event.stopPropagation()">
      <div class="search-input-wrapper">
        <input
          #searchInput
          matInput
          [placeholder]="placeholder"
          [formControl]="searchControl"
          (click)="$event.stopPropagation()"
          (keydown.space)="$event.stopPropagation()"
          autocomplete="off"
        />

        <button
          mat-icon-button
          type="button"
          aria-label="Clear / Close"
          class="clear-search-btn"
          (click)="onCloseClick($event)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>


    <div class="select-all-row" (click)="toggleSelectAllMultiple(); $event.stopPropagation()"
         *ngIf="!hideSelectAllOption">
      <mat-icon class="select-all-icon">done_all</mat-icon>
      <span class="select-all-text">Select All</span>
    </div>
    <mat-option
      *ngFor="let option of filteredOptions$ | async"
      [value]="option">
      {{ displayWithFn ? displayWithFn(option) : option[displayKey] }}
    </mat-option>
    <mat-option *ngIf="(filteredOptions$ | async)?.length === 0" disabled>
      No data available
    </mat-option>

  </mat-select>
  <button *ngIf="isShowPlusIcon"
          mat-icon-button
          matSuffix
          type="button"
          (click)="onAddButtonClick($event)"
  >
    <mat-icon>add</mat-icon>
  </button>
  <button
    mat-icon-button
    matSuffix
    type="button"
    aria-label="Refresh"
    (click)="onRefreshClick($event)">
    <mat-icon style="color: #757575">refresh</mat-icon>
  </button>

</mat-form-field>

